let skewMs = 0;
let offsetSec = 0;
let ready = false;

const pad = value => (value < 10 ? `0${value}` : String(value));

export const noteServerTime = (epochMs, offsetSeconds) => {
  if (!Number.isFinite(epochMs)) return;

  skewMs = epochMs - Date.now();
  offsetSec = Number.isFinite(offsetSeconds) ? offsetSeconds : 0;
  ready = true;
};

const serverMillis = () => Date.now() + skewMs + offsetSec * 1000;

export const formatServerClock = () => {
  if (!ready) return '';

  const totalSeconds = Math.floor(serverMillis() / 1000);
  const secondsInDay = ((totalSeconds % 86400) + 86400) % 86400;
  const hours = Math.floor(secondsInDay / 3600);
  const minutes = Math.floor((secondsInDay % 3600) / 60);
  const seconds = secondsInDay % 60;

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const msUntilNextServerSecond = () => {
  if (!ready) return 1000;

  const remainder = ((serverMillis() % 1000) + 1000) % 1000;
  return remainder === 0 ? 1000 : 1000 - remainder;
};
